import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class Leave extends Mixins(CommonView) {
    kurukuru: boolean = false;
    error: string = "";
    public user: BASEAPI.User = BASEAPI.user();
    public mode: "CONFIRM" | "COMPLETE" = "CONFIRM";
    public agree: boolean = false;
    public popup: boolean = false;

    element: HTMLElement = <HTMLElement>document.scrollingElement;

    public async created() {
        await this.init();
    }

    @Watch('$route')
    public async init() {
        if (await this.isLoginRedirect(true)) return;

        let response = await BASEAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
        } else {
            response.data.email = "";
            this.user = response.data;
        }
    }

    public async conf() {
        this.kurukuru = true;
        this.error = "";

        if(!this.agree){
            this.error = "注意事項に同意してください。";
            this.kurukuru = false;
            return;
        }

        let res = await BASEAPI.UserProductShipController.getUserProductShipListUsingGET(["BEFORE", "WAITING"]).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            this.kurukuru = false;
            return;
        }

        if(res.data.length > 0){
            this.error = "全ての景品が配送完了していない場合は、恐れ入りますが退会手続きができかねます。お手元に景品が届きましたら再度お手続きをお願いいたします。";
            this.kurukuru = false;
            return;
        }

        this.popup = true;
        this.kurukuru = false;
    }

    public async leave() {
        this.kurukuru = true;
        this.error = "";
        this.user.deleteFlag = true;

        let res = await BASEAPI.UserController.putUserDeleteUsingPUT(this.user).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            this.kurukuru = false;
            return;
        }

        this.popup = false;
        this.mode = "COMPLETE";
        await this.getUserAPI();
        this.kurukuru = false;
    }
}
